(function () {
  var STORAGE_KEY = 'oddit:recentlyViewed';
  var MAX_STORED = 20;

  function readStore() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      var arr = raw ? JSON.parse(raw) : [];
      return Array.isArray(arr) ? arr.filter(function (h) { return typeof h === 'string' && h; }) : [];
    } catch (e) {
      return [];
    }
  }

  function writeStore(arr) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(arr));
    } catch (e) {
      /* storage full / disabled — ignore */
    }
  }

  // Record the product currently being viewed: newest-first, de-duped, capped.
  function recordCurrent(handle) {
    if (!handle) return;
    var arr = readStore().filter(function (h) { return h !== handle; });
    arr.unshift(handle);
    writeStore(arr.slice(0, MAX_STORED));
  }

  // Re-append cards into the exact localStorage order and drop any that didn't
  // resolve to a requested handle (defensive — Liquid already returns in order).
  function reorderByHandles(track, handles) {
    var cards = Array.prototype.slice.call(track.children);
    var byHandle = {};
    cards.forEach(function (card) {
      var link = card.querySelector('a[href]');
      var href = link ? link.getAttribute('href') || '' : '';
      var match = href.match(/\/products\/([^/?#]+)/);
      if (match && !byHandle[match[1]]) byHandle[match[1]] = card;
    });
    var ordered = handles
      .map(function (h) { return byHandle[h]; })
      .filter(Boolean);
    if (!ordered.length) return false;
    track.innerHTML = '';
    ordered.forEach(function (card) { track.appendChild(card); });
    return true;
  }

  // The global reveal IntersectionObserver only observes nodes present at its
  // init, so AJAX-injected cards never animate in. Set stagger indices and
  // reveal them directly (mirrors the recommended-products section).
  function revealInjected(section) {
    section.querySelectorAll('[data-oddit-stagger]').forEach(function (container) {
      var idx = 0;
      Array.prototype.forEach.call(container.children, function (child) {
        if (child.classList && child.classList.contains('oddit-reveal')) {
          child.style.setProperty('--oddit-stagger-index', String(idx));
          idx += 1;
        }
      });
    });
    section.querySelectorAll('.oddit-reveal').forEach(function (el) {
      el.classList.add('is-visible');
    });
  }

  function buildCarousel(section) {
    var track = section.querySelector('[data-recently-viewed-track]');
    if (!track || track.children.length) return; // already populated — nothing to do

    var current = section.getAttribute('data-current-handle') || '';
    var limit = parseInt(section.getAttribute('data-products-to-show'), 10) || 5;
    var handles = readStore()
      .filter(function (h) { return h !== current; })
      .slice(0, limit);
    if (!handles.length) return; // first-time visitor — stay hidden

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var url =
      root +
      'search?type=product&section_id=' +
      encodeURIComponent(section.id) +
      '&q=' +
      encodeURIComponent(handles.join(','));

    fetch(url)
      .then(function (response) {
        if (!response.ok) throw new Error('Recently viewed request failed');
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fetchedTrack = doc.querySelector('[data-recently-viewed-track]');
        if (!fetchedTrack) return;

        track.innerHTML = fetchedTrack.innerHTML;
        if (!reorderByHandles(track, handles)) return; // no cards resolved — stay hidden

        section.style.display = '';
        revealInjected(section);
        initProgressBar(section);
        initDragScroll(section);
      })
      .catch(function () {
        /* network/parse failure — leave the section hidden */
      });
  }

  function initProgressBar(section) {
    var track = section.querySelector('[data-recently-viewed-track]');
    var indicator = section.querySelector('[data-recently-viewed-progress]');
    if (!track || !indicator) return;

    var progressBar = section.querySelector('.oddit-section-recently-viewed__progress');

    function updateProgress() {
      var maxScroll = track.scrollWidth - track.clientWidth;
      if (maxScroll <= 0) {
        // Items fit without overflow — no scrolling needed, so hide the bar.
        if (progressBar) progressBar.style.display = 'none';
        return;
      }

      if (progressBar) progressBar.style.display = '';

      var visibleRatio = track.clientWidth / track.scrollWidth;
      var indicatorWidthPct = Math.max(visibleRatio * 100, 10);
      var scrollProgress = track.scrollLeft / maxScroll;
      var availableSpacePct = 100 - indicatorWidthPct;
      var leftPct = scrollProgress * availableSpacePct;

      indicator.style.width = indicatorWidthPct + '%';
      indicator.style.left = leftPct + '%';
    }

    updateProgress();

    track.addEventListener('scroll', updateProgress, { passive: true });

    if (typeof ResizeObserver === 'function') {
      var ro = new ResizeObserver(updateProgress);
      ro.observe(track);
    } else {
      window.addEventListener('resize', updateProgress);
    }
  }

  function initDragScroll(section) {
    var track = section.querySelector('[data-recently-viewed-track]');
    if (!track) return;

    var desktop = window.matchMedia('(min-width: 990px)');
    var isDown = false;
    var moved = false;
    var startX = 0;
    var startScroll = 0;

    function onPointerDown(e) {
      if (!desktop.matches || e.button !== 0) return;
      isDown = true;
      moved = false;
      startX = e.clientX;
      startScroll = track.scrollLeft;
      track.classList.add('oddit-section-recently-viewed__track--dragging');
    }

    function onPointerMove(e) {
      if (!isDown) return;
      var delta = e.clientX - startX;
      if (Math.abs(delta) > 4) moved = true;
      track.scrollLeft = startScroll - delta;
      e.preventDefault();
    }

    function endDrag() {
      if (!isDown) return;
      isDown = false;
      track.classList.remove('oddit-section-recently-viewed__track--dragging');
    }

    track.addEventListener('pointerdown', onPointerDown);
    track.addEventListener('pointermove', onPointerMove);
    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);
    track.addEventListener('pointerleave', endDrag);

    // Suppress the click that follows a drag so cards aren't accidentally activated.
    track.addEventListener(
      'click',
      function (e) {
        if (moved) {
          e.preventDefault();
          e.stopPropagation();
          moved = false;
        }
      },
      true
    );

    track.addEventListener('dragstart', function (e) {
      if (desktop.matches) e.preventDefault();
    });
  }

  function initSection(section) {
    if (!section || section.dataset.recentlyViewedInited === 'true') return;
    section.dataset.recentlyViewedInited = 'true';

    // Track the product on the current page (no-op off product pages).
    recordCurrent(section.getAttribute('data-current-handle') || '');

    // If cards were already rendered server-side, just wire the chrome;
    // otherwise fetch + build from localStorage, which wires the chrome itself.
    var track = section.querySelector('[data-recently-viewed-track]');
    if (track && track.children.length) {
      section.style.display = '';
      initProgressBar(section);
      initDragScroll(section);
    } else {
      buildCarousel(section);
    }
  }

  function initAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var sections = scope.querySelectorAll('.oddit-section-recently-viewed');
    sections.forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // Theme editor: re-init when a section is added or reloaded.
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
